
import React, { useState } from 'react';
import './FAQ.css';
import NavigationMenu from './../navigationMenu/navigationMenu';
import Purse from './../purse/purse';
import ButtonVariant from './../buttonVariant/buttonVariant';
import Input from './../input/input';
import CopiBtn from './../copiBtn/copiBtn';
import CopiIcon from '../../img/Copy.png'
import Down from './../down/down';
import ButtonColor from './../buttonColor/buttonColor';
import ButtonVariantCentr from './../ButtonVariantCentr/ButtonVariantCentr';

const FAQ = ({ text }) => {
  const [isVariant, setIsVariant] = useState(false);

  return (
    <>
      <div className="">
        <NavigationMenu >
          <Purse title="FAQ">
            <div className="content_navigatino">
              <div onClick={() => setIsVariant(!isVariant)}>
                <ButtonVariant name="About Azara" isShow={true} />
              </div>
              <div>
                <ButtonVariantCentr name="Deposit & Withdrawal" />
              </div>
              <div onClick={() => setIsVariant(!isVariant)}>
                <ButtonVariant name="Account" />
              </div>
            </div>

            <div className="container_input_child">
              <Input placeholder="Поиск" isIcon={true} />
            </div>
            <Down title="What is Azara Wallet?" isNoneDown={true}>
              <div className="text_dowwn">Azara Wallet is a unique platform helping its users easily receive, send, withdraw and exchange cryptocurrencies. The platform is available to any cyptocurrency user.
                Azara Wallet is a platform and it doesn't buy or sell anything neither it promises any profit. All transactions are held between its users directly.</div>
            </Down>
            <Down title="What is Azara Wallet?" isNoneDown={true}>
              <div className="text_dowwn">Azara Wallet is a unique platform helping its users easily receive, send, withdraw and exchange cryptocurrencies. The platform is available to any cyptocurrency user.
                Azara Wallet is a platform and it doesn't buy or sell anything neither it promises any profit. All transactions are held between its users directly.</div>
            </Down>
            <Down title="What is Azara Wallet?" isNoneDown={true}>
              <div className="text_dowwn">Azara Wallet is a unique platform helping its users easily receive, send, withdraw and exchange cryptocurrencies. The platform is available to any cyptocurrency user.
                Azara Wallet is a platform and it doesn't buy or sell anything neither it promises any profit. All transactions are held between its users directly.</div>
            </Down>
            <Down title="What is Azara Wallet?" isNoneDown={true}>
              <div className="text_dowwn">Azara Wallet is a unique platform helping its users easily receive, send, withdraw and exchange cryptocurrencies. The platform is available to any cyptocurrency user.
                Azara Wallet is a platform and it doesn't buy or sell anything neither it promises any profit. All transactions are held between its users directly.</div>
            </Down>
            <Down title="What is Azara Wallet?" isNoneDown={true}>
              <div className="text_dowwn">Azara Wallet is a unique platform helping its users easily receive, send, withdraw and exchange cryptocurrencies. The platform is available to any cyptocurrency user.
                Azara Wallet is a platform and it doesn't buy or sell anything neither it promises any profit. All transactions are held between its users directly.</div>
            </Down>

            <div className="container_margin"></div>
            {!isVariant ? (
              <>

              </>
            ) : (<>

            </>)}
          </Purse>
        </NavigationMenu>
      </div>
    </>

  )
}

export default FAQ;